module.exports = __webpack_public_path__ + "static/media/image3.09cf7bef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/image3.png
// module id = 1257
// module chunks = 0